import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navItems = [{
    name: 'Product',
    path: '/product'
  }, {
    name: 'For Artists',
    path: '/for-artists'
  }, {
    name: 'For Venues',
    path: '/for-venues'
  }, {
    name: 'Use Cases',
    path: '/use-cases'
  }, {
    name: 'Pricing',
    path: '/pricing'
  }];
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5,
    ease: 'easeOut'
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? 'py-4' : 'py-6'}`} data-id="element-425">
      {/* Glassmorphism backdrop that fades in on scroll */}
      <div className={`absolute inset-0 transition-opacity duration-500 ${scrolled ? 'opacity-100 glass border-b-0' : 'opacity-0'}`} data-id="element-426"></div>

      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between relative z-10" data-id="element-427">
        <Link to="/" className="flex items-center gap-2 cursor-pointer group" data-id="element-428">
          <span className="text-2xl font-bold tracking-tight text-textMain group-hover:gradient-text transition-all" data-id="element-429">
            Booker
          </span>
          <div className="w-2 h-2 rounded-full bg-primary mt-1 group-hover:shadow-[0_0_10px_rgba(245,158,11,0.8)] transition-shadow" data-id="element-430"></div>
        </Link>

        {/* Pill-shaped Glass Nav */}
        <div className="hidden md:flex items-center gap-2 bg-surface/30 backdrop-blur-md border border-border/50 rounded-full px-4 py-1.5 shadow-lg" data-id="element-431">
          {navItems.map(item => {
          const isActive = location.pathname === item.path;
          return <Link key={item.name} to={item.path} className={`relative px-4 py-2 text-sm font-medium transition-colors group ${isActive ? 'text-textMain' : 'text-textMuted hover:text-textMain'}`} data-id="element-432">
                {item.name}
                <div className={`absolute bottom-1 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-primary transition-all duration-300 ${isActive ? 'opacity-100 scale-100' : 'opacity-0 scale-0 group-hover:opacity-50 group-hover:scale-100'}`} data-id="element-433"></div>
              </Link>;
        })}
        </div>

        <div className="flex items-center gap-4" data-id="element-434">
          <Link to="/login" className="hidden md:block text-sm font-medium text-textMuted hover:text-textMain transition-colors" data-id="element-435">
            Log in
          </Link>
          <Link to="/demo" className="hidden md:block px-4 py-2 text-sm font-medium text-textMain border border-border rounded-lg hover:bg-surface transition-colors" data-id="element-436">
            Book a demo
          </Link>
          <Link to="/onboarding" className="px-4 py-2 text-sm font-medium text-background bg-primary rounded-lg hover:bg-primaryHover transition-all shadow-[0_0_15px_rgba(245,158,11,0.3)] hover:shadow-[0_0_25px_rgba(245,158,11,0.6)] hover:-translate-y-0.5" data-id="element-437">
            Start free
          </Link>
        </div>
      </div>
    </motion.nav>;
}